import React from "react";
const riskFields = [
  { key: "general", label: "General Occupants (number)" },
  { key: "sleeping", label: "Sleeping Occupants (number)" },
  { key: "disabled", label: "Persons with Disabilities (number)" },
  { key: "young", label: "Young Persons (number)" },
  { key: "visitors", label: "Visitors (number)" },
  { key: "other", label: "Other Persons at Special Risk" }
];
export default function OccupantsForm({ data, onChange }) {
  return (
    <fieldset className="fra-fieldset">
      <legend>Occupants & Persons at Risk</legend>
      {riskFields.map(({ key, label }) => (
        <div className="fra-form-group" key={key}>
          <input
            type={key === "other" ? "text" : "number"}
            value={data[key] || ""}
            onChange={e => onChange({ ...data, [key]: e.target.value })}
            placeholder={label}
            min={0}
          />
          <label>{label}</label>
        </div>
      ))}
    </fieldset>
  );
}
